import React, { Component, Fragment } from "react";
import axios from "axios";
import * as urls from "../common/urls";
import { connect } from "react-redux";
import { getOrders, getOrder } from "../actions/orderActions";
// import { getCustomerReferrals } from "../actions/referralActions";
import { setPager } from "../actions/pagerActions";
import { withRouter } from "react-router";
import { utils } from "../common/utils";
import { ReferralStatus, AmountType, RewardTrigger } from "../common/enums";
import { Breakpoint } from "react-socks";
import { withTranslation } from "react-i18next";
import CurrencyFormat from "../components/CurrencyFormat";
import NewWindow from "../components/NewWindow";
import DiscountCodeDetails from "../components/DiscountCodeDetails";
import ReferralsTable from "../components/ReferralsTable";

class ReferralsList extends Component {
  state = {
    isDiscountPopUp: false,
    selectedDiscountCodeDetails: {},
    referrals: [],
    refereeActionLog: null,
    isReferralsLoaded: false,
  };

  getCustomerReferrals(customerId, page, pageSize) {
    const pagingParams =
      page !== undefined && pageSize !== undefined
        ? `?page=${page}&pageSize=${pageSize}`
        : "";
  
    axios.get(
      `${urls.GET_CUSTOMER_REFERRALS_URL.replace(":customerId", customerId)}${pagingParams}`,
      { headers: { "Content-Type": "application/json" } }
    ).then(res => {
      if(res.status === 200 && res.data) {
        this.setState({ referrals: res.data.customerReferrals, refereeActionLog:  res.data.customerRefereeActionLog, isReferralsLoaded: true });
      }
      
    });
  
    
  }

  componentDidMount() {
    // this.props.getCustomerReferrals(this.props.user.id, 1, 12)
    // static page size for now
    this.getCustomerReferrals(this.props.user.id, 1, 12);
  }

  onShowDiscountDetails(e, referral) {
    e.preventDefault();
    this.setState({
      isDiscountPopUp: true,
      selectedDiscountCodeDetails: {
        id: referral.id,
        discountCode: referral.discountCode,
        discountCodeAmountType: referral.discountCodeAmountType,
        discountValue: referral.discountValue,
        limitNumberToBeUsedInTotal: referral.limitNumberToBeUsedInTotal,
        discountCodeStartDate: referral.discountCodeStartDate,
        discountCodeEndDate: referral.discountCodeEndDate,
      },
    });
  }

  onCloseWindow() {
    this.setState({
      isDiscountPopUp: false,
      selectedDiscountCodeDetails: {},
    });
  }

  render() {
    const { t, settings } = this.props;
    const  referrals = this.state.referrals
    const refereeActionLog = this.state.refereeActionLog
    // if (!referrals || referrals.length === 0)
    //   return (
    //     <div className="alert alert-info fade show text-center margin-bottom-1x">
    //       <span className="alert-close" data-dismiss="alert"></span>
    //       <i className="icon-layers"></i>&nbsp;&nbsp;
    //       <strong>{t("My Referrals")}:</strong>{" "}
    //       {t("You haven't referred any customers yet.")}.
    //     </div>
    //   );

    return (
      <Fragment>
        
        <Breakpoint small down>
          <NewWindow
            title={`${t("Discount Voucher")}`}
            open={this.state.isDiscountPopUp}
            onClose={this.onCloseWindow.bind(this)}
            widthPercentage={90}
            heightPercentage={40}
          >
            <DiscountCodeDetails
              discountCodeDetails={this.state.selectedDiscountCodeDetails}
              settings={settings}
            />
          </NewWindow>
          <div className="accordion padding-top-1x" role="tablist">
            {refereeActionLog && (
              <div className="card" key={refereeActionLog.id}>
                <div className="card-header" role="tab">
                  <h6>
                  <span className="text-bold float-left mt-3">{t("You Have Been Referred By")}  </span>
                    <a
                      className={`btn btn-outline-info  float-right ${refereeActionLog.discountCode ? "" : "disabled"}`}
                      href={`#collapse${refereeActionLog.id}`}
                      onClick={(e) =>
                        this.onShowDiscountDetails(e, refereeActionLog)
                      }
                      data-parent="#accordion2"
                    >
                      
                      <span>{t(refereeActionLog.referralProgramName)} </span>
                      <span
                        className={`badge badge-pill ${utils.referral.getStatusColor(
                          refereeActionLog
                        )} `}
                      >
                        (
                        {t(
                          utils.referral.getStatus(
                            refereeActionLog.referralStatus
                          )
                        )}
                        )
                      </span>
                      {/* <span className="text-medium col-8">&nbsp;&nbsp;&nbsp;Total:&nbsp;<CurrencyFormat value={o.totalCustomerPrice + o.totalDeliveryFees} settings={settings} /></span> */}
                    </a>
                  </h6>
                </div>
                <div
                  className="collapse show"
                  id={`#collapse${refereeActionLog.id}`}
                  role="tabpanel"
                >
                  <div className="card-body form-group">
                    <div className="form-group row align-items-center">
                      <span className="col-4 col-form-label text-right">
                        {t("Referral Date")}:&nbsp;
                      </span>
                      <span className="text-medium col-8">
                        {utils.dates.getDateString(
                          refereeActionLog.referralDate
                        )}
                      </span>
                    </div>
                    <div className="form-group row align-items-center">
                      <span className="col-4 col-form-label text-right">
                        {t("Customer Name")}:&nbsp;
                      </span>
                      <span className="text-medium col-8">
                        {refereeActionLog.referrerFullName}
                      </span>
                    </div>
                    <div className={`form-group row align-items-center`}>
                      <span className="col-4 col-form-label text-right">
                        {t("Reward Eligibility")}:&nbsp;
                      </span>
                      {refereeActionLog.rewardTrigger ==
                        RewardTrigger.OnRefereePurchase && (
                        <span className="text-medium col-8">
                          {t("On Cusomter Purchasing")}
                        </span>
                      )}
                      {refereeActionLog.rewardTrigger ==
                        RewardTrigger.OnRefereeRegister && (
                        <span className="text-medium col-8">
                          {t("On Cusomter Registeration")}
                        </span>
                      )}
                    </div>

                    <div className="form-group row align-items-center">
                      <span className="col-4 col-form-label text-right">
                        {t("Program Name")}:&nbsp;
                      </span>
                      <span className="text-medium col-8">
                        {t(refereeActionLog.referralProgramName)}
                      </span>
                    </div>
                    <div className="form-group row align-items-center">
                      <span className="col-4 col-form-label text-right">
                        {t("Program Status")}:&nbsp;
                      </span>
                      <span className="text-medium col-8">
                        {refereeActionLog.referralProgramIsDeleted === true &&
                          t("Expired")}
                        {refereeActionLog.referralProgramIsDeleted === false &&
                          t("Active")}
                      </span>
                    </div>
                    <div className="form-group row align-items-center">
                      <span className="col-4 col-form-label text-right">
                        {t("Program Expiry Date")}:&nbsp;
                      </span>
                      <span className="text-medium col-8">
                        {refereeActionLog.programExpiryDate ? (
                          utils.dates.getDateString(
                            refereeActionLog.programExpiryDate
                          )
                        ) : (
                          <span>&mdash;</span>
                        )}
                      </span>
                    </div>

                    {/* <div className="padding-bottom-1x">
                                        <button className="btn btn-info" >{t("More Details")}</button>
                                    </div> */}
                  </div>
                </div>
              </div>
            )}
            {referrals &&
              referrals.map((referral) => (
                <div className="card" key={referral.id}>
                  <div className="card-header" role="tab">
                    <h6>
                      <a
                        className={`btn btn-outline-info ${referral.discountCode ? "" : "disabled"}`}
                        href={`#collapse${referral.id}`}
                        onClick={(e) => this.onShowDiscountDetails(e, referral)}
                        data-parent="#accordion2"
                      >
                        <span>{t(referral.referralProgramName)}</span>
                        <span
                          className={`badge badge-pill ${utils.referral.getStatusColor(
                            referral
                          )} `}
                        >
                          (
                          {t(utils.referral.getStatus(referral.referralStatus))}
                          )
                        </span>
                        {/* <span className="text-medium col-8">&nbsp;&nbsp;&nbsp;Total:&nbsp;<CurrencyFormat value={o.totalCustomerPrice + o.totalDeliveryFees} settings={settings} /></span> */}
                      </a>
                    </h6>
                  </div>
                  <div
                    className="collapse show"
                    id={`#collapse${referral.id}`}
                    role="tabpanel"
                  >
                    <div className="card-body form-group">
                      <div className="form-group row align-items-center">
                        <span className="col-4 col-form-label text-right">
                          {t("Referral Date")}:&nbsp;
                        </span>
                        <span className="text-medium col-8">
                          {utils.dates.getDateString(
                            referral.referralDate
                          )}
                        </span>
                      </div>
                      <div className="form-group row align-items-center">
                        <span className="col-4 col-form-label text-right">
                          {t("Customer Name")}:&nbsp;
                        </span>
                        <span className="text-medium col-8">
                          {referral.refereeFullName}
                        </span>
                      </div>
                      <div className={`form-group row align-items-center`}>
                        <span className="col-4 col-form-label text-right">
                          {t("Reward Eligibility")}:&nbsp;
                        </span>
                        {referral.rewardTrigger ==
                          RewardTrigger.OnRefereePurchase && (
                          <span className="text-medium col-8">
                            {t("On Cusomter Purchasing")}
                          </span>
                        )}
                        {referral.rewardTrigger ==
                          RewardTrigger.OnRefereeRegister && (
                          <span className="text-medium col-8">
                            {t("On Cusomter Registeration")}
                          </span>
                        )}
                      </div>

                      <div className="form-group row align-items-center">
                        <span className="col-4 col-form-label text-right">
                          {t("Program Name")}:&nbsp;
                        </span>
                        <span className="text-medium col-8">
                          {t(referral.referralProgramName)}
                        </span>
                      </div>
                      <div className="form-group row align-items-center">
                        <span className="col-4 col-form-label text-right">
                          {t("Program Status")}:&nbsp;
                        </span>
                        <span className="text-medium col-8">
                          {referral.referralProgramIsDeleted === true &&
                            t("Expired")}
                          {referral.referralProgramIsDeleted === false &&
                            t("Active")}
                        </span>
                      </div>
                      <div className="form-group row align-items-center">
                        <span className="col-4 col-form-label text-right">
                          {t("Program Expiry Date")}:&nbsp;
                        </span>
                        <span className="text-medium col-8">
                          {referral.programExpiryDate ? (
                            utils.dates.getDateString(
                              referral.programExpiryDate
                            )
                          ) : (
                            <span>&mdash;</span>
                          )}
                        </span>
                      </div>

                      {/* <div className="padding-bottom-1x">
                                            <button className="btn btn-info" >{t("More Details")}</button>
                                        </div> */}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </Breakpoint>
        <Breakpoint medium up>
          <NewWindow
            title={`${t("Discount Voucher")}`}
            open={this.state.isDiscountPopUp}
            onClose={this.onCloseWindow.bind(this)}
            widthPercentage = {40}
            heightPercentage = {40}
          >
            <DiscountCodeDetails
              discountCodeDetails={this.state.selectedDiscountCodeDetails}
              settings={settings}
            />
          </NewWindow>
          <div className="padding-top-2x mt-2 hidden-lg-up"></div>
                                   
          <div className="accordion" id="accordion" role="tablist">
            <div className="card">
              <div className="card-header" role="tab">
                <h6>
                  <a href="#activeReferrals" data-toggle="collapse">
                    {t("My Active Referrals")}
                  </a>
                </h6>
              </div>
              <div
                className="collapse show"
                id="activeReferrals"
                role="tabpanel"
                data-parent="#accordion"
              >
                <div className="card-body">
                  {this.state.isReferralsLoaded ? 
                  <ReferralsTable
                    referralsList={referrals.filter(
                      (item) => item.referralProgramIsDeleted === false
                    )}
                    onShowDiscountDetails={this.onShowDiscountDetails.bind(this)}
                    emptyMessage={!referrals || referrals.length === 0 ? t("You haven't referred any customers yet.") : t("You don't have any active referrals.")}
                  ></ReferralsTable>
                  :
                  <ReferralsTable
                    referralsList={referrals.filter(
                      (item) => item.referralProgramIsDeleted === false
                    )}
                    onShowDiscountDetails={this.onShowDiscountDetails.bind(this)}
                  ></ReferralsTable>}
                  
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" role="tab">
                <h6>
                  <a href="#inactiveReferrals" data-toggle="collapse">
                    {t("My Inactive Referrals")}
                  </a>
                </h6>
              </div>
              <div
                className="collapse"
                id="inactiveReferrals"
                role="tabpanel"
                data-parent="#accordion"
              >
                <div className="card-body">
                  {this.state.isReferralsLoaded ? 
                  <ReferralsTable
                    referralsList={referrals.filter(
                      (item) => item.referralProgramIsDeleted === true
                    )}
                    onShowDiscountDetails={this.onShowDiscountDetails.bind(
                      this
                    )}
                    emptyMessage={!referrals || referrals.length === 0 ? t("You haven't referred any customers yet.") : t("You don't have any inactive referrals.")}
                  ></ReferralsTable>
                  :
                  <ReferralsTable
                      referralsList={referrals.filter(
                        (item) => item.referralProgramIsDeleted === true
                      )}
                      onShowDiscountDetails={this.onShowDiscountDetails.bind(
                        this
                      )}
                  ></ReferralsTable>  
                }
                  
                </div>
              </div>
            </div>
          </div>
          {refereeActionLog && (
              <div className="card mt-5">
                <div className="card-header" role="tab">
                  <h6>
                    <span >
                      {t("You Have Been Referred By")}
                    </span>
                  </h6>
                </div>
                <div
                  className="collapse show"
                  role="tabpanel"
                >
                  <div className="card-body">
                    <ReferralsTable
                      referralsList={[refereeActionLog]}
                      onShowDiscountDetails={this.onShowDiscountDetails.bind(
                        this
                      )}
                    ></ReferralsTable>
                  </div>
                </div>
              </div>
            )}   
        </Breakpoint>
      </Fragment>
    );
  }
}

function mapStateToProps({ referrals, settings, user }, ownProps) {
  return { referrals, settings, user, ...ownProps };
}

export default withTranslation()(
  withRouter(
    connect(mapStateToProps, { setPager })(ReferralsList)
  )
);
